import { render, staticRenderFns } from "./UsersCard.vue?vue&type=template&id=a037420e&scoped=true&"
import script from "./UsersCard.vue?vue&type=script&lang=js&"
export * from "./UsersCard.vue?vue&type=script&lang=js&"
import style0 from "./UsersCard.vue?vue&type=style&index=0&id=a037420e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a037420e",
  null
  
)

export default component.exports